import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import LogoImg from './bicamsinlogo.jpg';
import NormalImg from '../common/Img';
import Button from '../common/Button';
import NewParticipantForm from './NewParticipantForm';
import { saveParticipant, fetchParticipant } from '../../actions';

const Img = styled(NormalImg)`
  width: 200px;
  margin: 20px;
  display: block;
`;
const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;

class ParticipantDetailsPage extends React.Component {

  state = {
    redirect: false
  }

  componentDidMount = () => {
    const { match } = this.props;
    if (match.params.id) {
      this.props.fetchParticipant(match.params.id);
    }
  }

  saveParticipant = ({ gender, currentAge, yearsOfEducation, diagnosis, diseaseSubtype, yearsSinceDiagnosis, centreNo, dateValid }) => {
    return this.props.saveParticipant({ gender, currentAge, yearsOfEducation, diagnosis, diseaseSubtype, yearsSinceDiagnosis, centreNo, dateValid }).then((data) => { this.setState({ redirect: true, participant: data.participant })},
    );
  }

  render() {
    return (
      <div className="normalPage">
        <div className="container">
          <div className="row">
              <div className="col-xs-6"> 
                <Img src={LogoImg} alt="Bicams Logo" />
              </div>
              <div className="col-xs-6">
                <Link to="/participants"><ButtonA className="btn btn-lg">Go back </ButtonA></Link>
                <Link to="/logout"><ButtonB className="btn btn-lg">Logout</ButtonB></Link>
              </div>
            </div>
        {
          this.state.redirect ?
          <div className="row">
          <div className="col-md-12">
          <h1 className="bicamsColor">New participant successfully submitted</h1>
          <h2>BICAMS NUMBER: {this.state.participant.Id}</h2>
          <Link to={"/new_exam/" + this.state.participant.Id}><ButtonA className="btn btn-lg">Start New Exam</ButtonA></Link>
          <Link to="/participants"><ButtonA className="btn btn-lg">View BICAMS Participants</ButtonA></Link>
          </div>
          </div> :
           <div className="row">
              <NewParticipantForm saveParticipant={this.saveParticipant} />
            </div>
        }
        </div>
      </div>
    );
  }

}

function mapStateToProps(state, props) {
  const { match } = props;
  if (match.params.id) {
    return {
      participant: state.participants.find(item => item.Id === match.params.id)
    }
  }

  return { participant: null };
}

export default connect(mapStateToProps, { saveParticipant, fetchParticipant })(ParticipantDetailsPage);


// WEBPACK FOOTER //
// ./src/components/participants/NewParticipantPage.js